import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

function ModalHabilitations({ operation, onClose }) {
  const [profils, setProfils] = useState([]);
  const [habilitations, setHabilitations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [operation.id]);

  const loadData = async () => {
    setLoading(true);
    
    // Charger tous les profils
    const { data: profilsData, error: profilsError } = await supabase
      .from('profils')
      .select('*')
      .order('nom', { ascending: true });
    
    if (profilsError) {
      console.error('Erreur chargement profils:', profilsError);
    } else {
      setProfils(profilsData || []);
    }
    
    // Charger les habilitations existantes pour cette opération
    const { data: habilitationsData, error: habilitationsError } = await supabase
      .from('profil_operations')
      .select('profil_id')
      .eq('operation_id', operation.id);
    
    if (habilitationsError) {
      console.error('Erreur chargement habilitations:', habilitationsError);
    } else {
      const profilIds = (habilitationsData || []).map(h => h.profil_id);
      setHabilitations(profilIds);
    }
    
    setLoading(false);
  };

  const toggleHabilitation = async (profilId) => {
    const isHabilite = habilitations.includes(profilId);
    
    if (isHabilite) {
      // Retirer l'habilitation
      const { error } = await supabase
        .from('profil_operations')
        .delete()
        .eq('profil_id', profilId)
        .eq('operation_id', operation.id);
      
      if (error) {
        console.error('Erreur suppression habilitation:', error);
        alert('Erreur lors de la suppression de l\'habilitation');
      } else {
        setHabilitations(habilitations.filter(id => id !== profilId));
      }
    } else {
      // Ajouter l'habilitation
      const { error } = await supabase
        .from('profil_operations')
        .insert([{
          profil_id: profilId,
          operation_id: operation.id
        }]);
      
      if (error) {
        console.error('Erreur ajout habilitation:', error);
        alert('Erreur lors de l\'ajout de l\'habilitation');
      } else {
        setHabilitations([...habilitations, profilId]);
      }
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 3000
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        padding: '40px',
        width: '600px',
        maxWidth: '90%',
        maxHeight: '80vh',
        overflow: 'auto',
        border: '2px solid #1aabf9',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px'
        }}>
          <div>
            <h2 style={{
              color: '#212529',
              margin: 0,
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '8px'
            }}>
              🔐 Habilitations
            </h2>
            <p style={{
              color: '#6c757d',
              fontSize: '14px',
              margin: 0
            }}>
              Opération: <strong>{operation.nom}</strong>
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              color: '#6c757d',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            Fermer
          </button>
        </div>

        {loading ? (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#6c757d'
          }}>
            Chargement...
          </div>
        ) : (
          <>
            <div style={{
              padding: '15px',
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '10px',
              fontSize: '13px',
              color: '#856404',
              marginBottom: '25px'
            }}>
              ℹ️ <strong>Important :</strong> Seuls les profils cochés pourront effectuer cette opération. Les opérateurs non habilités verront leur scan refusé.
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {profils.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#6c757d',
                  fontSize: '14px'
                }}>
                  Aucun profil créé. Créez des profils dans la section "Gestion des Profils".
                </div>
              ) : (
                profils.map(profil => {
                  const isHabilite = habilitations.includes(profil.id);
                  
                  return (
                    <label
                      key={profil.id}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '16px',
                        backgroundColor: isHabilite ? '#e3f2fd' : '#f8f9fa',
                        border: isHabilite ? '2px solid #1aabf9' : '1px solid #dee2e6',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (!isHabilite) {
                          e.currentTarget.style.backgroundColor = '#ffffff';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isHabilite) {
                          e.currentTarget.style.backgroundColor = '#f8f9fa';
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isHabilite}
                        onChange={() => toggleHabilitation(profil.id)}
                        style={{
                          marginRight: '12px',
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                          accentColor: '#1aabf9'
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{
                          color: isHabilite ? '#1aabf9' : '#495057',
                          fontSize: '15px',
                          fontWeight: isHabilite ? '600' : '500'
                        }}>
                          {profil.nom}
                        </div>
                        {profil.sections && profil.sections.length > 0 && (
                          <div style={{
                            color: '#6c757d',
                            fontSize: '12px',
                            marginTop: '4px'
                          }}>
                            {profil.sections.length} accès autorisé{profil.sections.length > 1 ? 's' : ''}
                          </div>
                        )}
                      </div>
                      {isHabilite && (
                        <div style={{
                          backgroundColor: '#1aabf9',
                          color: '#ffffff',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '11px',
                          fontWeight: '600'
                        }}>
                          ✓ Habilité
                        </div>
                      )}
                    </label>
                  );
                })
              )}
            </div>

            <div style={{
              marginTop: '25px',
              padding: '15px',
              backgroundColor: '#e3f2fd',
              border: '1px solid #1aabf9',
              borderRadius: '10px',
              fontSize: '13px',
              color: '#1976d2'
            }}>
              💡 <strong>Astuce :</strong> {habilitations.length} profil{habilitations.length > 1 ? 's' : ''} habilité{habilitations.length > 1 ? 's' : ''} pour cette opération.
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ModalHabilitations;
